export default __webpack_public_path__ + "static/media/express.6a48f133.png";